module.exports = __webpack_public_path__ + "static/media/thumbnail-video-1@3x.a6b4b3ea.png";